"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ark = require("@dateam/ark");
var _TableHeaderCell = _interopRequireDefault(require("./TableHeaderCell"));
var _ColumnCheckbox = _interopRequireDefault(require("./ColumnCheckbox"));
const TableHeader = _ref => {
  var _th;
  let {
    data,
    columns,
    selectedField,
    onSelectionChange
  } = _ref;
  const showSelectedColumn = _react.default.useMemo(() => (0, _ark.isString)(selectedField), [selectedField]);
  const allIsSelected = _react.default.useMemo(() => {
    if (showSelectedColumn === false || !Array.isArray(data) || !(0, _ark.isString)(selectedField)) return false;
    return !data.some(dataEntry => (0, _ark.getPropertySafe)(dataEntry, selectedField) !== true);
  }, [data, selectedField, showSelectedColumn]);
  const handleSelectionChange = _react.default.useCallback((selected, event) => {
    if ((0, _ark.isFunction)(onSelectionChange)) {
      onSelectionChange(selected);
    }
  }, [onSelectionChange]);
  const columnChildren = _react.default.useMemo(() => {
    const cells = [];
    if (showSelectedColumn) {
      cells.push(_th || (_th = /*#__PURE__*/_react.default.createElement("th", {
        key: 0,
        className: "tableHeaderCol"
      }, /*#__PURE__*/_react.default.createElement(_ColumnCheckbox.default, {
        checked: allIsSelected,
        onChange: handleSelectionChange
      }))));
    }
    columns.forEach((column, colIdx) => {
      cells.push( /*#__PURE__*/_react.default.createElement(_TableHeaderCell.default, {
        key: colIdx + 1,
        column: column
      }));
    });
    return cells;
  }, [columns, allIsSelected, showSelectedColumn]);
  return /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", {
    className: "tableHeaderRow"
  }, columnChildren));
};

// TableHeader.propTypes = {
//     columns: propTypes.arrayOf(propTypes.shape({})).isRequired,
//     selectedField: propTypes.string
// };

// TableHeader.defaultProps = {
//     selectedField: undefined
// };
var _default = exports.default = TableHeader;